module.exports = __webpack_public_path__ + "static/media/error.63ee7c12.svg";